<!--
 * @Author: 李修垚 1530465910@qq.com
 * @Date: 2023-10-27 12:00:17
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-12-04 11:59:04
 * @FilePath: \s-pages\src\views\housing_registration_inquiry\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="divs">
    <div class="froms">
      <div class="tilte">商品房合同备案查询</div>
      <div class="separate"></div>
      <div>
        <el-form :model="prop" class="from" :rules="rule">
          <div style="width: 3%"></div>
          <el-form-item label="合同编号：" prop="htbh">
            <el-input v-model="prop.htbh" class="data_input" />
          </el-form-item>
          <el-form-item label="买受人：" prop="msr">
            <el-input v-model="prop.msr" class="data_input" />
          </el-form-item>
          <el-form-item label="身份证号：" prop="zjhm">
            <el-input class="data_input" v-model="prop.zjhm" />
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="QueryContract()">查询</el-button>
          </el-form-item>
          <div style="width: 3%"></div>
        </el-form>
      </div>
    </div>
    <div class="tables">
      <table class="table">
        <tr class="table_1">
          <td>合同号</td>
          <td>备案状态</td>
          <td>备案日期</td>
          <td>合同总金额（元）</td>
        </tr>
        <tr>
          <td style="width: 35%;">
            <span>{{ contract.contract_number }}</span>
          </td>
          <td style="width: 15%;">
            <span>{{ contract.state }}</span>
          </td>
          <td style="width: 20%;">
            <span>{{ contract.filing_date }}</span>
          </td>
          <td style="width: 30%;"><span>{{ contract.total_amount }}</span></td>
        </tr>
      </table>
      <table class="table">
        <tr class="table_1">
          <td>房屋坐落</td>
          <td>建筑面积(m²)</td>
          <td>套内面积(m²)</td>
          <td>房屋用途</td>
        </tr>
        <tr>
          <td style="width: 35%;">
            <span>{{ contract.location }}</span>
          </td>
          <td style="width: 15%;">
            <span>{{ contract.floor_space }}</span>
          </td>
          <td style="width: 20%;">
            <span>{{ contract.building_area }}</span>
          </td>
          <td style="width: 30%;"><span>{{ contract.purpose }}</span></td>
        </tr>
      </table>
      <table class="table">
        <tr class="table_1">
          <td>买方人</td>
          <td>证件号</td>
        </tr>
        <tr>
          <td style="width: 30%;">
            <span>{{ contract.buyer }}</span>
          </td>
          <td style="width: 70%;">
            <span>{{ contract.id }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import { ElMessage } from 'element-plus'
import { GetContractInfo } from '../../api/housing_registration_inquiry.js';

const prop = reactive({
  htbh: '',
  msr: '',
  zjhm: '',
});

const contract = reactive({
  floor_space: '-',
  contract_number: '-',
  state: '-',
  filing_date: '-',
  total_amount: '-',
  location: '-',
  building_area: '-',
  purpose: '-',
  buyer: '-',
  id: '-',
});

const QueryContract = async () => {
  if (prop.htbh !== '' && prop.msr !== '' && prop.zjhm !== '') {
    const { data } = await GetContractInfo(prop);
    console.log(data);
    if (data) {
      contract.contract_number = data.htbh;
      contract.state = data.bazt;
      contract.filing_date = data.barq;
      contract.total_amount = data.zje;
      contract.location = data.fwzl;
      contract.floor_space = data.jzmj;
      contract.building_area = data.tnmj;
      contract.purpose = data.fwyt;
      contract.buyer = data.msr;
      contract.id = data.zjhm;
    } else {
      ElMessage('未查询到该合同.');
    }
  } else {
    ElMessage('请检查查询条件是否全部输入.');
  }
};

const rule = {
  htbh: [{
    required: true,
    message: '请输入房屋编号',
    trigger: 'blur',
  }],
  msr: [{
    required: true,
    message: '请输入买受人姓名',
    trigger: 'blur',
  }],
  zjhm: [{
    required: true,
    message: '请输入证件号码',
    trigger: 'blur',
  }],
}


</script>

<style lang="scss" scoped>
.from {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  margin-top: 1.5%;
}

.froms {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 130px;
  width: 100%;
}

.tilte {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ef701d;
  height: 40%;
  width: 100%;
  color: white;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
}

.separate {
  width: 100%;
  height: 5%;
  background-color: #ca5f18;
}

.query {
  background-color: #EF701D;
  border: 0px solid white;
  color: white;
  width: 7%;
}

.data_input,
.data_select {
  background-color: #f2f2f2;
  border: 1px solid #ccc;
}

.tables {
  width: 90%;
}

.table {
  margin-top: 3%;
  border: 1px solid #E3AB68;
  width: 100%;
  border-collapse: collapse;
}

td {
  border: 1px solid #E3AB68;
  height: 30px;
}

.table_1 {
  background-color: #E3AB68;
}

.divs {
  width: 98%;
  height: 98%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border: 1px solid orange;
  border-radius: 10px;
}
</style>